function _(t,r,e){r.exports=function(){try{return Object.keys("primitive"),!0}catch(t){return!1}}}
//# sourceMappingURL=is-implemented.min.js.map